import React from 'react';
import Icon from '../../../components/AppIcon';

const ScanInstructions = ({ 
  hasCamera = true,
  isScanning = false 
}) => {
  const instructions = [
    {
      icon: 'Receipt',
      title: 'Coloca el ticket',
      description: 'Asegúrate de tener el ticket físico del restaurante a mano'
    },
    {
      icon: 'Camera',
      title: 'Fotografía el ticket',
      description: 'Coloca el ticket completo dentro del marco'
    },
    {
      icon: 'Sparkles',
      title: 'IA extrae los datos',
      description: 'La inteligencia artificial leerá automáticamente todos los conceptos'
    }
  ];

  const troubleshootingTips = [
    {
      icon: 'Sun',
      title: 'Buena iluminación',
      description: 'Asegúrate de tener suficiente luz natural o artificial'
    },
    {
      icon: 'Focus',
      title: 'Texto legible',
      description: 'El texto debe estar nítido y sin borrones'
    },
    {
      icon: 'ImageOff',
      title: 'Sin sombras',
      description: 'Evita sombras o reflejos en el ticket'
    }
  ];

  return (
    <div className="space-y-6">
      {/* Main Instructions */}
      <div className="text-center space-y-4">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-primary/10 rounded-full">
          <Icon name="Receipt" size={32} className="text-primary" />
        </div>
        
        <div>
          <h1 className="text-2xl font-bold text-foreground mb-2">
            Escanea tu ticket
          </h1>
          <p className="text-text-secondary max-w-md mx-auto">
            Toma una foto de tu ticket y la IA extraerá automáticamente todos los conceptos e importes
          </p>
        </div>
      </div>
      {/* Step by Step Instructions */}
      <div className="bg-surface border border-border rounded-lg p-4">
        <h3 className="font-semibold text-foreground mb-4 flex items-center">
          <Icon name="List" size={16} className="mr-2" />
          Cómo funciona
        </h3>
        
        <div className="space-y-3">
          {instructions?.map((step, index) => (
            <div key={index} className="flex items-start space-x-3">
              <div className="flex-shrink-0 w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center">
                <Icon name={step?.icon} size={16} className="text-primary" />
              </div>
              <div>
                <h4 className="font-medium text-foreground text-sm">
                  {step?.title}
                </h4>
                <p className="text-xs text-text-secondary">
                  {step?.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Troubleshooting Tips */}
      {hasCamera && (
        <div className="bg-muted/30 border border-border rounded-lg p-4">
          <h3 className="font-semibold text-foreground mb-4 flex items-center">
            <Icon name="HelpCircle" size={16} className="mr-2" />
            Consejos para una mejor captura
          </h3>
          
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
            {troubleshootingTips?.map((tip, index) => (
              <div key={index} className="text-center">
                <div className="inline-flex items-center justify-center w-10 h-10 bg-accent/10 rounded-full mb-2">
                  <Icon name={tip?.icon} size={16} className="text-accent" />
                </div>
                <h4 className="font-medium text-foreground text-sm mb-1">
                  {tip?.title}
                </h4>
                <p className="text-xs text-text-secondary">
                  {tip?.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      )}
      {/* Current Status */}
      {isScanning && (
        <div className="bg-primary/5 border border-primary/20 rounded-lg p-4 text-center">
          <div className="flex items-center justify-center space-x-2 text-primary">
            <div className="animate-pulse-soft">
              <Icon name="Search" size={16} />
            </div>
            <span className="font-medium">Buscando código QR...</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ScanInstructions;